import { render } from "./SectionsDetail.vue?vue&type=template&id=75cae525"
import script from "./SectionsDetail.vue?vue&type=script&lang=js"
export * from "./SectionsDetail.vue?vue&type=script&lang=js"

import "./SectionsDetail.vue?vue&type=style&index=0&id=75cae525&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__